<template>
    <div v-if="isShow && loading"> 欢迎使用{{ siteInfo.SiteName }} </div>
    <iframe v-if="!isShow && loading" class="frame-body" :src="templateUrl">
    </iframe>
</template>
<script>
    import { getDashboard } from "../apis/httpHelper"
    import { qweIsEmpty } from "../common/commonHelper";
    export default {
        name:"welcome",
        data:function(){
            return {
                isShow:true,
                templateUrl:"",
                loading:false
            }
        },  
        created:function(){
            getDashboard().then(x=>{
                this.loading = true;
                let url = x.Result;
                if(!qweIsEmpty(url)){
                    this.isShow = false;
                    this.templateUrl = this.$store.state.baseUrl + "/api/customPage/" + url;
                }
            })
        },
        computed:{
            siteInfo:function(){
                return this.$store.state.siteInfo
            }
        }
    }
</script>